import { render, staticRenderFns } from "./AttesaEdiDetails.vue?vue&type=template&id=1c63973b&scoped=true"
import script from "./AttesaEdiDetails.vue?vue&type=script&lang=js"
export * from "./AttesaEdiDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c63973b",
  null
  
)

export default component.exports